// extracted by mini-css-extract-plugin
export var bannerDown = "MarktdatenInfoSection-module--bannerDown--d31a1";
export var bannerInner = "MarktdatenInfoSection-module--bannerInner--06b5c";
export var bannerUp = "MarktdatenInfoSection-module--bannerUp--14976";
export var blockColor = "MarktdatenInfoSection-module--blockColor--0a792";
export var blockColor2 = "MarktdatenInfoSection-module--blockColor2--77e8d";
export var calendarFilter = "MarktdatenInfoSection-module--calendarFilter--02d5e";
export var chart = "MarktdatenInfoSection-module--chart--8a8bd";
export var chart1 = "MarktdatenInfoSection-module--chart1--72246";
export var chart2 = "MarktdatenInfoSection-module--chart2--04399";
export var chartData = "MarktdatenInfoSection-module--chartData--71f4b";
export var chartTitle = "MarktdatenInfoSection-module--chartTitle--67649";
export var chartTittle = "MarktdatenInfoSection-module--chartTittle--5a076";
export var cover = "MarktdatenInfoSection-module--cover--ed1cf";
export var dateBubble = "MarktdatenInfoSection-module--dateBubble--ce994";
export var filterOptions = "MarktdatenInfoSection-module--filterOptions--a9a16";
export var filters = "MarktdatenInfoSection-module--filters--ab3b4";
export var firstCellTitle = "MarktdatenInfoSection-module--firstCellTitle--731f8";
export var firstFigure = "MarktdatenInfoSection-module--firstFigure--afef5";
export var graph = "MarktdatenInfoSection-module--graph--bc4f5";
export var groupFilter = "MarktdatenInfoSection-module--groupFilter--3f768";
export var icons = "MarktdatenInfoSection-module--icons--e52ff";
export var isActive = "MarktdatenInfoSection-module--isActive--4282e";
export var lineName = "MarktdatenInfoSection-module--lineName--b9274";
export var lineNameContainer = "MarktdatenInfoSection-module--lineNameContainer--314bf";
export var name = "MarktdatenInfoSection-module--name--492bb";
export var tabSection = "MarktdatenInfoSection-module--tabSection--0db62";
export var table = "MarktdatenInfoSection-module--table--68b95";
export var textContent = "MarktdatenInfoSection-module--textContent--7712a";
export var tooltipContainer = "MarktdatenInfoSection-module--tooltipContainer--ec305";